module.exports = __webpack_public_path__ + "img/gb9877_1-88-35x50x8.prt.fa1ef61e.jpg";